import React from 'react';
import { Component } from 'react';
import { localizeUrl } from '@tesla/parse-locale';
import Forms from '../contents/forms/Forms';
import { InitialState } from '../data/initialState';
import { connect } from 'react-redux';
import Header from './Header';
import CallHandler from '../utils/Call';
import Validation from '../data/validation';
import Constants from '../data/constants';
import { linkPlaceholder, getLocale, i18n, getCountry } from '../utils/TranslationUtils';

class PersonalForms extends Component {
    constructor(props) {
        super(props);

        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'form-interaction',
                interaction: 'view-open',
                formType: 'Test Drive',
                engagementType: 'User Requested'
            });
        }

        const countryCode = (typeof window.Tesla !== "undefined") ? window.Tesla.country.toUpperCase() : "US";
        this.setCountry(countryCode);
        this.currForm = Forms()["form" + this.getCountry()];
        if (typeof this.currForm === "undefined") {
            this.currForm = Forms().FormDefault;
        }
        this.state = {
            countryList: null,
            provinceList: null,
            cityList: null,
            showECheckbox: false
        }
        this.CallHandler = new CallHandler();
        this.CallHandler.getCountryData()
            .then( response => {
                const { countryList, provinceList, cityList } = response.data;
                this.setState({
                    countryList,
                    provinceList,
                    cityList
                });
            })

        setTimeout( () => {
            const ipFromCookie = (typeof window.TeslaCommon !== "undefined") ? window.TeslaCommon.getCookie("ip_info") : {};
            const _ipInfo = JSON.parse(ipFromCookie);
            if (typeof _ipInfo !== "undefined" && _ipInfo != null && typeof Tesla !== "undefined") {
                if (_ipInfo.country_code === "us" && window.Tesla.locale === "en_US") {
                    if (["CA", "CO", "FL", "HI", "NM", "NY", "OR", "VA", "DC"].includes(_ipInfo.state_code)) {
                        this.setState({
                            showECheckbox: true
                        });
                    }
                }
            }
        }, 300)
    }

    setCountry(value) {
        this._country = value;
    }

    getCountry(value) {
        return this._country;
    }

    validate(e) {
        let countryValidation = Validation()[this.getCountry()];
        if (typeof countryValidation === "undefined") {
            countryValidation = Validation().US;
        }

        const l = countryValidation.length,
              { values } = this.props;

        let empty = {};
        for (let i = 0; i < l; i++) {
            let key = countryValidation[i];

            empty[key] = {
                class: '',
                msg: ''
            }
        }

        this.props.store.dispatch({
            type: Constants().VALIDATE_FORM,
            invalid: empty
        });

        const form = (typeof window.tesla !== "undefined") ? window.tesla.App.strings['Test_Drive/All'].content.form : {};

        let invalid = {};
        let isValid = true;

        for (let i = 0; i < l; i++) {
            let key = countryValidation[i];

            if (typeof values[key] === "undefined" || values[key] === "") {
                invalid[key] = {
                    class: 'tds-form-item--error',
                    msg: form.error.required
                }
                isValid = false;
            }
        }

        if (!isValid) {
            let newState = Object.assign({}, this.state.validation);
            for (let k in invalid) {
                newState[k] = invalid[k];
            }

            this.props.store.dispatch({
                type: Constants().VALIDATE_FORM,
                invalid: invalid
            });
        }
        else {
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'form-interaction',
                    interaction: 'personal-info-complete',
                    formType: 'Test Drive',
                    engagementType: 'User Requested'
                });
            }

            this.props.handleSubmit(e);
        }
    }

    render() {
        const CurrForm = this.currForm;
        const {
            containerClass,
            handleChange,
            values,
            updateValue,
            locale,
            showDriversLicenseCopy,
            showMinimumAgeToDrive,
            showGenericDriversLicenseCopy,
        } = this.props;

        const form = (typeof window.tesla !== "undefined") ? window.tesla.App.strings['Test_Drive/All'].content.form : {};
        const first = linkPlaceholder(
            i18n('form.title2'),
            { LEARN_MORE: i18n('form.title2Lbl') },
            localizeUrl('/support/test-drive', {
                locale,
            }),
        );
        const paragraphs = [first];
        if (showDriversLicenseCopy) {
            paragraphs.push(i18n('form.title3'));
        }

        if (showGenericDriversLicenseCopy) {
            paragraphs.push(i18n('form.needsDriversLicenseGeneric'));
        }

        if (showMinimumAgeToDrive) {
            const market = getCountry();
            paragraphs.push(i18n('form.minimumAgeToDrive', {
                AGE: Constants().AGE_TO_DRIVE[market] || 21,
            }));
        }

        return (
            <div className={'content-container forms-container ' + containerClass}>
                <Header 
                    title={i18n('form.title')}
                    paragraphs={paragraphs}
                />
                <div className='forms-inner-container'>
                    <CurrForm
                        handleChange={handleChange} 
                        countryList={this.state.countryList}
                        provinceList={this.state.provinceList}
                        cityList={this.state.cityList}
                        showECheckbox={this.state.showECheckbox}
                        values={values}
                        form={form}
                        updateValue={updateValue} />
                    <div className='btn-container'>
                        <button className="tds-btn tds-btn--blue" data-section="formsSection" onClick={this.validate.bind(this)} id="edit-submit-td-ajax">{i18n('form.next')}</button>
                    </div>
                    <p className='disclaimer-txt'>{i18n('form.disclaimer')}</p>
                </div>
            </div>
        );
    }
}

PersonalForms.defaultProps = InitialState().formsSection

export default connect(state => ({
    containerClass: state.formsSection.containerClass,
    locale: getLocale(),
    showDriversLicenseCopy: state.flags.showDriversLicenseCopy,
    showMinimumAgeToDrive: state.flags.showMinimumAgeToDrive,
    showGenericDriversLicenseCopy: state.flags.showGenericDriversLicenseCopy,
}))(PersonalForms);
